// src/plugins/vuetify.js

import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

const opts = {
  theme: {
    dark: false,
    themes: {
      dark: {
        primary: "#000000",
        accent: "#597F70",
        secondary: "#707070",
        info: "#2196F3",
        warning: "#FFC107",
        error: "#FF5252",
        success: "#4CAF50",
        light: "#fdfcfc",
      },
      light: {
        primary: "#000000",
        accent: "#597F70",
        secondary: "#707070",
        info: "#2196F3",
        warning: "#FFC107",
        error: "#FF5252",
        success: "#4CAF50",
        light: "#fdfcfc",
      },
    },
  },
};

export default new Vuetify(opts);
